module.exports = {"path":["Dashboard","Transaction Group","Transaction List"]}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/search/index.json
// module id = v9rP
// module chunks = 58